import React, { Component, PropTypes } from 'react';
import {
    addMonths,
    subMonths,
    format,
    startOfWeek,
    endOfWeek,
    startOfMonth,
    endOfMonth,
    addDays,
    isSameMonth,
    isSameDay,
    isPast,
    isFuture,
    closestTo,
    isWeekend,
    differenceInCalendarDays,
    isEqual,
    getYear,
} from 'date-fns'
import { capitalize } from 'lodash';
import classNames from 'classnames';
import ru from 'date-fns/locale/ru';
import IconControl from 'components/IconControl'
import ButtonControl from 'components/ButtonControl'
import './BigCalendar.scss';
import { Map } from 'immutable'
import { toMoneyFormat } from '../../../tools/number'
import {
    INSTANT_PRICES_TYPE_NAMES,
    TYPE_FIXED_DATE_WITH_DRIVER,
    TYPE_FIXED_DATE_WITH_LOADERS,
    TYPE_FLEXIBLE_DATE_WITH_DRIVER,
} from '../../constants/Instantprices'
import ga from 'react-ga'
import isMobile from 'ismobilejs'
import SingleDatePickerControl from 'components/SingleDatePickerControl'
import ActionCreators from 'actions/ActionCreators'
import { getInstantPrices, getServicePrices } from 'api'
import RouteStore from 'stores/RouteStore'
import InstantBookingStore from 'stores/InstantBookingStore';

const LEFT_BUTTON_ARROW = <IconControl name="leftArrow" size="m" />;
const RIGHT_BUTTON_ARROW = <IconControl name="rightArrow" size="m" />;

function getStateFromStores() {
    return {
        dates: RouteStore.getDates(),
    }
}

class BigCalendar extends Component {

    static propTypes = {
        daysInSelection: PropTypes.number,
        prices: PropTypes.instanceOf(Map),
        services: PropTypes.instanceOf(Map),
        onDatesChange: PropTypes.func,
        dates: PropTypes.object,
        type: PropTypes.oneOf([
            TYPE_FIXED_DATE_WITH_DRIVER,
            TYPE_FIXED_DATE_WITH_LOADERS,
            TYPE_FLEXIBLE_DATE_WITH_DRIVER,
        ]),
        selectedCategory: PropTypes.object,
        logMode: PropTypes.bool,
        activeTab: PropTypes.number,
        price: PropTypes.number,
        showSideNav: PropTypes.bool,
    }

    state = {
        currentMonth: new Date(),
        selectedDates: [],
        hoveredDate: null,
        mobileHideCells: true,
    }

    _onChange = () => {
        this.setState(getStateFromStores());
    }

    componentDidMount() {
        RouteStore.addChangeListener(this._onChange)

        if (this.props.dates.from) {
            // Avoid error "Cannot dispatch in the middle of a dispatch" with help of setTimeout
            setTimeout(() => {
                this.onDateClick(this.props.dates.from, true, this.bestPrice(this.props.dates.from))
                this.setState({
                    currentMonth: this.props.dates.from,
                })
            }, 0)
        }
    }

    componentWillUnmount() {
        RouteStore.removeChangeListener(this._onChange)
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.dates && this.props.dates.from) {
            const isBestPrice = this.bestPrice(this.props.dates.from)

            if (prevProps.price > 0 && this.props.price > 0 && prevProps.price !== this.props.price) {
                ga.event({
                    category: 'instant_booking_orders',
                    action: isBestPrice ? 'best_price_updated' : 'common_price_updated',
                    label: this.props.selectedCategory.name,
                    value: parseInt(this.props.price, 10),
                })
            }
        }

        if (prevProps.daysInSelection !== this.props.daysInSelection) {
            if (this.props.dates && this.props.dates.from) {
                const isBestPrice = this.bestPrice(this.props.dates.from)
                this.onDateClick(this.props.dates.from, true, isBestPrice)
            } else {
                this.setState({
                    selectedDates: [],
                    hoveredDate: null,
                })
                this.onDateClick(null, false)
            }
        }

        if (prevProps.showSideNav !== this.props.showSideNav) {
            if (!this.props.showSideNav) {
                this.setState({
                    selectedDates: [],
                })
            }
        }
    }

    nextMonth = () => {
        this.setState({
            currentMonth: addMonths(this.state.currentMonth, 1),
        })
    }

    prevMonth = () => {
        this.setState({
            currentMonth: subMonths(this.state.currentMonth, 1),
        })
    }

    onDateClick = (date, showTotal = false, isBestPrice = false, sendAnalytics = false) => {
        console.log('onDateClick вызвана:', { date, showTotal, isBestPrice, sendAnalytics });

        if (this.props.daysInSelection <= 1) {
            this.setState({
                selectedDates: [date],
            });
            console.log('Выбрана одна дата:', date);

            this.props.onDatesChange([date], showTotal);
        } else {
            const selectedDates = [date];
            console.log('Выбрана начальная дата:', date);

            for (let i = 1; i <= this.props.daysInSelection - 1; i++) {
                const newDay = addDays(date, i);
                selectedDates.push(newDay);
                console.log('Добавлена следующая дата:', newDay);
            }

            this.setState({ selectedDates });
            console.log('Массив выбранных дат:', selectedDates);

            this.props.onDatesChange(selectedDates, showTotal);
        }

        console.log('Обновление цены через ActionCreators');
        ActionCreators.updateParameterPrice({ round_trip: InstantBookingStore.getBasePrice() });

        if (sendAnalytics) {
            console.log('Отправка аналитики:', {
                category: 'clicks',
                action: isBestPrice ? 'best_price_instant_booking' : 'common_price_instant_booking',
                label: this.props.selectedCategory.name,
                value: parseInt(this.props.price, 10),
            });

            ga.event({
                category: 'clicks',
                action: isBestPrice ? 'best_price_instant_booking' : 'common_price_instant_booking',
                label: this.props.selectedCategory.name,
                value: parseInt(this.props.price, 10),
            });

            ga.event({
                category: 'clicks',
                action: 'calendar_price_click',
                label: this.props.selectedCategory.name,
                value: 1,
            });

            if (window.ym) {
                console.log('Отправка аналитики в Яндекс');
                window.ym('1315865', 'reachGoal', 'calendar_price_click');
            }
        }

        // Добавляем обновление состояния для активации кнопки
        this.setState({ dateWasSelected: true });
        InstantBookingStore.setDateWasSelected(true);  // Обновляем глобальное состояние
        console.log('Дата была выбрана, флаг установлен в true');

        console.log('onDateClick завершена.');
    }

    onMouseEnterCell = date => {
        this.setState({
            hoveredDate: date,
        })
    }

    onMouseLeaveBody = () => {
        this.setState({
            hoveredDate: null,
        })
    }

    onShowAllDaysClick = () => {
        ga.event({
            category: 'instant_booking_buttons',
            action: 'show_all_days_s4_instant_booking',
            label: this.props.selectedCategory.name,
            value: 1,
        })

        this.setState({
            mobileHideCells: false,
        })
    }

    bestPrice = day => {
        const priceData = this.props.prices.get(format(day, 'YYYY-MM-DD', { locale: ru }))

        return !!(
            priceData &&
            priceData.date_desc.best_price &&
            (this.props.type === TYPE_FIXED_DATE_WITH_DRIVER || this.props.type === TYPE_FIXED_DATE_WITH_LOADERS)
        )
    }

    renderHeader = () => {
        const dateFormat = "MMMM YYYY"
        return (
            <div className="BigCalendar-header BigCalendar-gridRowMonth BigCalendar-gridFlexMiddle">
                <div className="BigCalendar-gridCol BigCalendar-start">
                    <div className="BigCalendar-icon" onClick={this.prevMonth}>
                        {LEFT_BUTTON_ARROW}
                    </div>
                </div>
                <div className="BigCalendar-gridCol BigCalendar-gridColCenter BigCalendar-headerMonth">
                    <span>
                        {capitalize(format(this.state.currentMonth, dateFormat, { locale: ru }))}
                    </span>
                </div>
                <div className="BigCalendar-gridCol BigCalendar-gridColEnd" onClick={this.nextMonth}>
                    <div className="BigCalendar-icon">{RIGHT_BUTTON_ARROW}</div>
                </div>
            </div>
        )
    }

    renderDays = () => {
        const dateFormat = 'dd'
        const days = []
        let startDate = startOfWeek(this.state.currentMonth, { weekStartsOn: 1 })

        for (let i = 0; i < 7; i++) {
            days.push(
                <div className="BigCalendar-gridCol BigCalendar-gridColCenter" key={i}>
                    {capitalize(format(addDays(startDate, i), dateFormat, { locale: ru }))}
                </div>,
            )
        }

        return <div className="BigCalendar-days BigCalendar-gridRow">{days}</div>
    }

    renderCells = () => {
        const { currentMonth, selectedDates, hoveredDate, dates } = this.state
        const monthStart = startOfMonth(currentMonth)
        const monthEnd = endOfMonth(monthStart)
        const startDate = startOfWeek(monthStart, { weekStartsOn: 1 })
        const endDate = endOfWeek(monthEnd, { weekStartsOn: 1 })
        const todayDate = !this.props.logMode ? new Date() : startDate

        const dateFormat = 'D'
        const rows = []
        const select = day => selectedDates.find(selectedDate => isSameDay(day, selectedDate))
        const hover = (day, hoveredDate) => {
            // if (!hoveredDate || select) {
            if (!hoveredDate || select) {
                return false
            }

            const is = isSameDay(day, hoveredDate) || isSameDay(day, addDays(hoveredDate, daysInSelectionSelected))
            if (is && daysInSelectionSelected < this.props.daysInSelection) {
                daysInSelectionSelected++
                return true
            }

            return false
        }
        const today = day => isSameDay(day, todayDate)
        const past = day => !today(day) && isPast(day)
        const disabled = day => !this.props.logMode && (past(day) || (this.props.type === TYPE_FLEXIBLE_DATE_WITH_DRIVER && (today(day) || isSameDay(day, addDays(todayDate, 1)))))
        const closestDayToToday = (day, endDate) => {
            const cloneDay = day
            const datesOfMonth = []
            while (day <= endDate) {
                if (!isFuture(day) && !today(day)) {
                    datesOfMonth.push(day)
                }
                day = addDays(day, 1)
            }

            if (datesOfMonth.length === 0) {
                datesOfMonth.push(cloneDay)
            }

            return startOfWeek(addDays(closestTo(todayDate, datesOfMonth), 1), { weekStartsOn: 1 })
        }
        const dayPrice = day => {
            const priceData = this.props.prices.get(format(day, 'YYYY-MM-DD', { locale: ru }))
            if (!priceData) {
                return 0
            }

            const minPrice = () => {
                let minPrice = Object.values(priceData.part_day[0])[0].price
                Object.values(priceData.part_day).forEach(time => {
                    time = Object.values(time)[0]
                    if (minPrice > time.price) {
                        minPrice = time.price
                    }
                })

                return minPrice
            }

            const wholeDayPriceData = Object.values(priceData.part_day[0])[0]

            switch (this.props.type) {
                case TYPE_FLEXIBLE_DATE_WITH_DRIVER:
                    return priceData.date_desc.flex_price
                case TYPE_FIXED_DATE_WITH_DRIVER:
                    if (today(day)) {
                        return minPrice()
                    } else {
                        return wholeDayPriceData ? wholeDayPriceData.price : 0
                    }
                case TYPE_FIXED_DATE_WITH_LOADERS:
                    const loadersPrice =
                        this.props.services.size > 0 &&
                            this.props.services.get('price_loader') ? this.props.services.get('price_loader').price : 0

                    if (today(day)) {
                        return minPrice() + loadersPrice
                    } else {
                        return wholeDayPriceData ? wholeDayPriceData.price + loadersPrice : 0
                    }
                default:
                    return wholeDayPriceData ? wholeDayPriceData.price : 0
            }
        }

        // const preparedStartDate = isSameMonth(currentMonth, todayDate) ? closestDayToToday(startDate, endDate) : startDate
        const preparedStartDate = (dates && dates.calendarStartDate) || todayDate //dayPrice(todayDate) ? todayDate : addDays(todayDate, 1);

        const hide = day => {
            if (!this.state.mobileHideCells) {
                return false
            }

            return false;

            /*if (!isMobile.phone) {
                return false
            }

            if (differenceInCalendarDays(day, preparedStartDate) > 7) {
                return true
            }*/
        }

        let days = []
        let day = preparedStartDate
        let formattedDate = ''
        let daysInSelectionSelected = 0
        let daysInRow = isMobile.phone ? 2 : 5;

        const endDay = addDays(day, 6)

        while (day <= endDay) {
            for (let i = 0; i < daysInRow && day <= endDay; i++) {
                formattedDate = format(day, dateFormat, { locale: ru })

                const cloneDay = day
                const isBestPrice = this.bestPrice(day)
                const price = dayPrice(day)

                const classes = classNames([
                    'BigCalendar-gridCol BigCalendar-bodyCol BigCalendar-bodyCell',
                    {
                        'BigCalendar-bodyCell--disabled': disabled(day) || !price,
                        /*'BigCalendar-bodyCell--today': today(day),*/
                        'BigCalendar-bodyCell--selected': select(day),
                        'BigCalendar-bodyCell--hover': hover(day, hoveredDate),
                        'BigCalendar-bodyCell--bestPrice': isBestPrice,
                        'BigCalendar-bodyCell--weekend': isWeekend(day),
                        'BigCalendar-bodyCell--hide': hide(day),
                    },
                ])

                if (isMobile.phone && (disabled(day) || !price)) {
                    day = addDays(day, 1)
                    continue
                }

                // New year holidays
                if (isEqual(day, new Date(getYear(todayDate), 0, 1)) ||
                    isEqual(day, new Date(getYear(todayDate), 0, 2)) ||
                    isEqual(day, new Date(getYear(todayDate), 0, 7))) {
                    days.push(
                        <div
                            className={classNames([
                                'BigCalendar-gridCol BigCalendar-bodyCol BigCalendar-bodyCell',
                                {
                                    'BigCalendar-bodyCell--disabled': true,
                                    /*'BigCalendar-bodyCell--today': today(day),*/
                                    'BigCalendar-bodyCell--hover': hover(day, hoveredDate),
                                    'BigCalendar-bodyCell--hide': hide(day),
                                },
                            ])}
                            key={day}
                            onMouseEnter={this.onMouseEnterCell.bind(this, cloneDay)}
                        >
                            <span className="BigCalendar-fullDay">{format(day, 'D MMMM', { locale: ru })}</span>
                            {today(day) ? <span className="BigCalendar-bodyCellToday">Сегодня</span> : null}
                            <span
                                className="BigCalendar-fullDayOfWeek">{capitalize(format(day, 'dddd', { locale: ru }))}</span>
                            <span className="BigCalendar-bodyCellNumber">{formattedDate}</span>
                        </div>,
                    )
                } else {
                    days.push(
                        <div className={classes}
                            key={day}
                            onMouseEnter={this.onMouseEnterCell.bind(this, cloneDay)}
                            onClick={this.onDateClick.bind(this, cloneDay, true, isBestPrice, true)}
                        >
                            <div>
                                <div className="BigCalendar-bodyCell-top">
                                    <span className="BigCalendar-fullDay">{format(day, 'D MMMM', { locale: ru })}</span>
                                    <span
                                        className="BigCalendar-fullDayOfWeek">{capitalize(format(day, 'dd', { locale: ru }))}</span>
                                </div>

                                <div>
                                    {price > 0 ? <span
                                        className="BigCalendar-bodyCellPrice">{toMoneyFormat(price)}₽</span> : null}
                                    {isBestPrice ?
                                        <span className="BigCalendar-bodyCellBestPrice">лучшая цена</span> : null}
                                    {today(day) ? <span className="BigCalendar-bodyCellToday">сегодня</span> : null}
                                    <span className="BigCalendar-bodyCellPriceArrow">{RIGHT_BUTTON_ARROW}</span>
                                </div>
                            </div>

                            {
                                (!disabled(day) && price > 0) &&
                                <div>
                                    <span className="BigCalendar-bodyCellLink">
                                        {select(day) ? '✓ Выбрана дата' : 'Выбрать'}
                                    </span>
                                </div>
                            }
                        </div>,
                    )
                }

                day = addDays(day, 1)
            }
            if (day > endDay) {
                formattedDate = format(day, dateFormat, { locale: ru })
                const cloneDay = day
                const isBestPrice = this.bestPrice(day)
                const price = dayPrice(day)

                const classes = classNames([
                    'BigCalendar-gridCol BigCalendar-bodyCol BigCalendar-bodyCell BigCalendar-bodyCellOtherDays',
                    {
                        'BigCalendar-bodyCell--disabled': disabled(day) || !price,
                        /*'BigCalendar-bodyCell--today': today(day),*/
                        'BigCalendar-bodyCell--selected': select(day),
                        'BigCalendar-bodyCell--hover': hover(day, hoveredDate),
                        // 'BigCalendar-bodyCell--bestPrice': isBestPrice,
                        'BigCalendar-bodyCell--weekend': isWeekend(day),
                        'BigCalendar-bodyCell--hide': hide(day),
                    },
                ])

                days.push(
                    <div className={classes}
                         key={day}
                         onMouseEnter={this.onMouseEnterCell.bind(this, cloneDay)}
                         onClick={this.onDateClick.bind(this, cloneDay, true, isBestPrice, true)}
                    >
                        <div>
                            <div className="BigCalendar-bodyCellOtherDays-priceBlock">
                                <div className="BigCalendar-bodyCell-top">
                                    <span className="BigCalendar-fullDay BigCalendar-bodyCellOtherDays-fullDay">{format(day, 'D MMMM', { locale: ru })} и позже...</span>
                                </div>

                                <div>
                                    {price > 0 ? <span className="BigCalendar-bodyCellPrice">{toMoneyFormat(price)}₽</span> : null}
                                    <span className="BigCalendar-bodyCellOtherDays-priceInfo">Цена в последующие дни</span>
                                    <span className="BigCalendar-bodyCellPriceArrow">{RIGHT_BUTTON_ARROW}</span>
                                </div>
                            </div>

                            {
                                (/* !disabled(day) && */ price > 0) &&
                                <div>
                                    <span className="BigCalendar-bodyCellLink" onClick={this.showOtherDaysPicker}>Выбрать другой день</span>
                                </div>
                            }
                        </div>
                        <div className="BigCalendar-bodyCellOtherDays-fakeCells">
                            <div className="BigCalendar-bodyCellOtherDays-fakeCells-fakeCell" style={{ width: "5%" }}></div>
                            <div className="BigCalendar-bodyCellOtherDays-fakeCells-fakeCell" style={{ width: "35%" }}></div>
                            <div className="BigCalendar-bodyCellOtherDays-fakeCells-fakeCell" style={{ width: "30%" }}></div>
                            <div className="BigCalendar-bodyCellOtherDays-fakeCells-fakeCell" style={{ width: "25%" }}></div>
                            <div className="BigCalendar-bodyCellOtherDays-fakeCells-fakeCell" style={{ width: "15%" }}></div>
                        </div>
                    </div>
                )
            }
            rows.push(
                <div className="BigCalendar-gridRow BigCalendar-bodyRow" key={day}>
                    {days}
                </div>,
            )
            days = []
        }

        return <div className="BigCalendar-body" onMouseLeave={this.onMouseLeaveBody}>{rows}</div>
    }

    renderMobileShowAllDaysButton = () => {
        if (!isMobile.phone) {
            return null
        }

        if (!this.state.mobileHideCells) {
            return false
        }

        /*return (
            <ButtonControl
                className="BigCalendar-showAllDaysBtn"
                view="sky"
                size="m"
                onClick={this.onShowAllDaysClick}>
                Показать все дни
            </ButtonControl>
        )*/
    }

    hideOtherDaysPicker = () => {
        this.setState({
            otherDaysPickerIsVisible: false
        })
    }

    showOtherDaysPicker = (e) => {
        e.stopPropagation();
        this.setState({
            otherDaysPickerIsVisible: true,
            selectedDates: []
        });
        ActionCreators.selectInstantBookingPartDay(Map({}));
        ActionCreators.calculateInstantBookingPrice();
        ActionCreators.updateDates({
            from: null
        });
        this.setState({ dateWasSelected: false });
        InstantBookingStore.setDateWasSelected(false);  // Обновляем глобальное состояние
        console.log('Дата была выбрана, флаг установлен в false');
    }

    onSelectDayOtherDaysPicker = (e, day) => {
        ActionCreators.showLoadingOverlay()
        ActionCreators.updateDates({
            calendarStartDate: day
        });
        ActionCreators.selectInstantBookingPartDay(Map({}));

        Promise.all([getInstantPrices(), getServicePrices()])
            .then(
                ([response, servicesResponse]) => {
                    ActionCreators.setInstantBookingHash(response.hash)
                    ActionCreators.setInstantBookingPrices(response.prices.price_pred)
                    ActionCreators.setInstantBookingServices(servicesResponse.prices.price_services)
                    ActionCreators.setInstantPriceDistance(response.distance > 0 ? response.distance : 0)
                    ActionCreators.setInstantGoogleMapsRoute(response.prices.order.routes.overview_polyline.points)
                    ActionCreators.calculateInstantBookingPrice();
                    ActionCreators.hideLoadingOverlay()
                    return Promise.resolve()
                },
                error => {
                    ActionCreators.hideLoadingOverlay()
                    return Promise.reject()
                }
            );
    }

    render() {
        const classes = classNames([
            'BigCalendar',
            /*{
                'BigCalendar-hide': isMobile.phone && this.props.activeTab === undefined,
            },*/
        ])

        return (
            <div className={classes}>
                {/* {this.renderHeader()}*/}
                {/*{this.renderDays()}*/}
                {this.renderCells()}
                {this.renderMobileShowAllDaysButton()}

                <SingleDatePickerControl
                    visible={this.state.otherDaysPickerIsVisible}
                    hideDaypicker={this.hideOtherDaysPicker}
                    onDaySelect={this.onSelectDayOtherDaysPicker} />
            </div>
        );
    }
}

export default BigCalendar;



// WEBPACK FOOTER //
// ./client/components/BigCalendar/BigCalendar.js